
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About`}</h1>
    <h2>{`Riddles`}</h2>
    <p>{`Riddles will be devised by the CBS faculty, staff and students.`}</p>
    <h2>{`Technology and Programming`}</h2>
    <p>{`Lilli Anders`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;